import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Input.module.css';

const RadioButtons = props => (
    <div className={cn(styles.radioButtons, props.className)}>
        {
            props.options.map((option, index) => {
                const id = `${props.id}_${index}`;
                return (
                    <label
                        htmlFor={id}
                        key={id}
                        className={styles.radioButton}
                    >
                        <input
                            id={id}
                            name={props.name}
                            type="radio"
                            value={option.value}
                            checked={props.value === option.value}
                            onBlur={props.onBlur}
                            onChange={props.onChange}
                        />
                        <span />
                        {option.label}
                    </label>
                );
            })
        }
    </div>
);

RadioButtons.propTypes = {
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
};

export default RadioButtons;
